// api/services/distributors.ts
import { handleRequest } from '@/api';
import type { Distributor } from '@/types';

interface DistributorPayload {
    distributor_name: string;
    default_share_pct?: string;
    country_code?: string | null;
    help_email?: string | null;
}

interface DistributorUpdatePayload {
    distributor_name?: string;
    default_share_pct?: string;
    country_code?: string | null;
    help_email?: string | null;
    archived?: boolean;
}

interface DistributorListResponse {
    distributors: Distributor[];
    total: number;
}

export const getDistributors = (includeArchived = false): Promise<DistributorListResponse> =>
    handleRequest<DistributorListResponse>('get', `/distributors/?include_archived=${includeArchived}`);

export const createDistributor = (payload: DistributorPayload): Promise<Distributor> =>
    handleRequest<Distributor>('post', '/distributors/', payload, 'Distributor created successfully!');

export const updateDistributor = (id: number, payload: DistributorUpdatePayload): Promise<Distributor> =>
    handleRequest<Distributor>('patch', `/distributors/${id}`, payload, 'Distributor updated successfully');

export const assignDor = (distributorId: number, entityType: number, entityId: number): Promise<{ detail: string }> =>
    handleRequest<{ detail: string }>(
        'patch',
        `/distributors/${distributorId}/assign-dor?entity_type=${entityType}&entity_id=${entityId}`,
        {},
        'Distributor of Record assigned'
    );
